import * as React from 'react'
import { cn } from '../../utils/cn'
import { fileToDataURL } from '../../utils/file'
import { FileUploadContext } from './file-upload-context'

export function FileUploadRoot({
  children,
  className,
  defaultValue,
  id,
  inProgress = false,
  name,
  progress,
  size = 'md',
  value: valueProp,
  onValueChange,
  ...props
}: FileUploadRoot.Props) {
  const [value, setValue] = React.useState(defaultValue)
  async function updateValue(value?: File | string) {
    if (value instanceof File) {
      setValue(await fileToDataURL(value))
      onValueChange?.(value)
    } else {
      setValue(value)
    }
  }

  React.useEffect(() => {
    updateValue(valueProp ?? defaultValue)
  }, [valueProp])

  return (
    <FileUploadContext.Provider
      value={{
        id,
        inProgress,
        name,
        progress,
        size,
        value,
        setValue: updateValue,
      }}
    >
      <div
        className={cn(
          'relative',
          {
            sm: 'h-7',
            md: 'h-9',
          }[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    </FileUploadContext.Provider>
  )
}

export namespace FileUploadRoot {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    defaultValue?: string
    id?: string
    inProgress?: boolean
    name?: string
    progress?: number
    size?: 'sm' | 'md'
    value?: string
    onValueChange?: (value: File) => void
  }
}
